import React from "react";
import EntryForm from "./EntryForm";

function App() {
  return (
    <div>
      <div className="text-center my-4">
        <img
          src="gamify.jpeg"
          alt="Gamify Logo"
          style={{ maxWidth: 220, height: "auto" }}
        />
      </div>
      <h2 className="text-center mb-4">Regina x FivebyFive x Promotigo Test Page</h2>
      <EntryForm />
    </div>
  );
}

export default App;
